module.exports = __webpack_public_path__ + "img/art-3.36bd809f.png";